import React from "react"

import * as Headless from "@headlessui/react"
import clsx from "clsx"

export function Fieldset({
  className,
  ...props
}: Omit<Headless.FieldsetProps, `as` | `className`> & { className?: string }) {
  return (
    <Headless.Fieldset
      {...props}
      className={clsx(
        className,
        `*:data-[slot=text]:mt-1 [&>*+[data-slot=control]]:mt-6`,
      )}
    />
  )
}

export function Legend({
  className,
  ...props
}: Omit<Headless.LegendProps, `as` | `className`> & { className?: string }) {
  return (
    <Headless.Legend
      data-slot="legend"
      {...props}
      className={clsx(
        className,
        `text-base/6 font-semibold text-foreground data-disabled:opacity-50 sm:text-sm/6`,
      )}
    />
  )
}

export function FieldGroup({
  className,
  ...props
}: React.ComponentPropsWithoutRef<`div`>) {
  return (
    <div
      data-slot="control"
      {...props}
      className={clsx(className, `space-y-8`)}
    />
  )
}

export function Field({
  className,
  ...props
}: Omit<Headless.FieldProps, `as` | `className`> & { className?: string }) {
  return (
    <Headless.Field
      {...props}
      className={clsx(
        className,
        `[&>[data-slot=label]+[data-slot=control]]:mt-3`,
        `[&>[data-slot=label]+[data-slot=description]]:mt-1`,
        `[&>[data-slot=description]+[data-slot=control]]:mt-3`,
        `[&>[data-slot=control]+[data-slot=description]]:mt-3`,
        `[&>[data-slot=control]+[data-slot=error]]:mt-3`,
        `*:data-[slot=label]:font-medium`,
      )}
    />
  )
}

export function Label({
  className,
  ...props
}: Omit<Headless.LabelProps, `as` | `className`> & { className?: string }) {
  return (
    <Headless.Label
      data-slot="label"
      {...props}
      className={clsx(
        className,
        `text-base/6 text-foreground select-none data-disabled:opacity-50 sm:text-sm/6`,
      )}
    />
  )
}

export function Description({
  className,
  ...props
}: Omit<Headless.DescriptionProps, `as` | `className`> & {
  className?: string
}) {
  return (
    <Headless.Description
      data-slot="description"
      {...props}
      className={clsx(
        className,
        `text-base/6 text-muted data-disabled:opacity-50 sm:text-sm/6`,
      )}
    />
  )
}

export function ErrorMessage({
  className,
  ...props
}: Omit<Headless.DescriptionProps, `as` | `className`> & {
  className?: string
}) {
  return (
    <Headless.Description
      data-slot="error"
      {...props}
      className={clsx(
        className,
        `text-base/6 text-danger data-disabled:opacity-50 sm:text-sm/6`,
      )}
    />
  )
}
